<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text
        }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de cuentas c. y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="cabTBien" :items="cuentasc" :items-per-page="15" :search="buscar"
          class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">CUENTA CONTABLE</v-toolbar-title>
              <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion cuentas c. -->
              <v-btn text fab x-small color="accent" @click="crearPDF()" class="mr-1">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin Impresion cuentas c. -->

              <v-spacer />
              <!-- Formulario busqueda de cuentas c. -->
              <v-text-field class="text-xs-center" v-model.trim="buscar" @keyup="listar()" append-icon="search" dense
                label="Búsqueda" hide-details></v-text-field>
              <!-- Fin Formulario Busqueda de cuentas c. -->
              <v-spacer />
              <!-- Modal crear y modificar cuentas c. -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn fab x-small dark color="primary" v-on="on">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" sm="3">
                          <v-text-field dense v-model.trim="cuenta" label="Cuenta"
                            :rules="[v => !!v || 'requerido', Rules.sinespacio]" maxlength="11"
                            :disabled="editedIndex == 1" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="9">
                          <v-text-field dense v-model.trim="denominacion" label="Denominación"
                            :rules="[v => !!v || 'requerido', Rules.unespacio]" maxlength="80" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense :items="cm.tipo_ctas" v-model="tipo_cta" label="Tipo de Cuenta"
                            :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense :items="cm.uso_ctas" v-model="uso_cta" label="Uso Cuenta"
                            :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                        </v-col>
                        <!-- Mensaje error cuentas c. -->
                        <v-col cols="12" v-if="mensajeTipo != ''">
                          <v-alert text dense type="error">{{ mensajeTipo }}</v-alert>
                        </v-col>
                        <!-- Mensaje error cuentas c. -->
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar cuentas c. -->

              <!-- Modal activar, desactivar cuentas c. -->
              <v-dialog v-model="adModal" max-width="400">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Activar Cuenta?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccion == 2">¿Desactivar Cuenta?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    la cuentas c. {{ adId + " " + adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrar">Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar">Activar</v-btn>
                    <v-btn v-if="adAccion == 2" text x-small color="warning" @click="desactivar">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar cuentas c. -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar cuentas c. -->

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <!--<v-btn text x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>-->
              <v-btn text x-small color="success">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text small color="warning" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
              <!--<v-btn text x-small color="warning">Inactivo</v-btn>-->
            </template>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-btn x-small icon>
              <v-icon color="info" @click="editItem(item)">edit</v-icon>
            </v-btn>
            <v-btn x-small icon v-if="esSuperadministrador">
              <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opciones editar, eliminar cuentas c. -->
        </v-data-table>
        <!-- Fin Listado de cuentas c. y opciones de titulo, busqueda, nuevo, etc -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      cuentasc: [],
      dialog: false,
      cabTBien: [
        { text: "Cuenta", value: "cuenta", sortable: false },
        { text: "Denominación", value: "denominacion", sortable: false },
        { text: "Tipo Cta", value: "tipo_cta", align: "center", sortable: false },
        { text: "Uso Cta", value: "uso_cta", align: "center", sortable: false },
        { text: "Condición", value: "condicion", align: "center", sortable: false },
        { text: "OPC.", value: "opciones", sortable: false },
      ],

      buscar: "",
      editedIndex: -1,
      cuenta: "",
      denominacion: "",
      tipo_cta: "",
      uso_cta: "E",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      mensajeTipo: "",

      desabilitar: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      Rules: {
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Tipo Bien" : "Actualizar Tipo Bien";
    },
    ...mapState(["usuarioState", "empresaState"]),
    ...mapGetters(["esSuperadministrador"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    /* Listar cuentas c. */
    listar() {
      let me = this;
      me.loading = true;

      axios
        .get("api/Cuentasc/ListarCuentascFiltro", {
          params: {
            buscar: me.buscar == "" ? "-" : me.buscar,
          },
        })
        .then(function (response) {
          me.cuentasc = response.data;
          me.loading = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    /* Fin Listar cuentas c. */

    /* Editar y guardar cuentas c. */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        //Código para editar
        axios
          .put("api/Cuentasc/Actualizar", {
            cuenta: me.cuenta,
            denominacion: me.denominacion,
            tipo_cta: me.tipo_cta,
            uso_cta: me.uso_cta
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeTipo = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/Cuentasc/Crear", {
            cuenta: me.cuenta,
            denominacion: me.denominacion,
            tipo_cta: me.tipo_cta,
            uso_cta: me.uso_cta
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeTipo = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar cuentas c. */

    /* Limpiar mensaje cuentas c. */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeTipo = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje cuentas c. */

    /* Editar cuentas c. item */
    editItem(item) {
      this.cuenta = item.cuenta;
      this.denominacion = item.denominacion;
      this.tipo_cta = item.tipo_cta;
      this.uso_cta = item.uso_cta;
      this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar cuentas c. item */

    /* Cerrar ventana cuentas c. */
    close() {
      this.dialog = false;
      this.limpiar();
    },
    /* Fin Cerrar ventana cuentas c. */

    /* Limpiar cuentas c. item */
    limpiar() {
      this.cuenta = "";
      this.denominacion = "";
      this.tipo_cta = "";
      this.uso_cta = "E";
      this.mensajeTipo = "";
      this.editedIndex = -1;
    },
    /* Fin Limpiar cuentas c. item */

    /* Desactivar, activar cuentas c. */
    desactivar() {
      let me = this;

      axios
        .put("api/Cuentasc/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.denominacion;
      this.adId = item.cuenta;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;
      axios
        .put("api/Cuentasc/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar cuentas c. */

    /* Eliminar cuentas c. */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar el cuentas c. " + item.denominacion + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/Cuentasc/Eliminar/" + item.cuenta)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar cuentas c. */

    /* Crear PDF cuentas c. */
    crearPDF() {
      var columns = [
        { header: "Cuenta", dataKey: "cuenta" },
        { header: "Denominación", dataKey: "denominacion" },
        { header: "T", dataKey: "tipo_cta" },
        { header: "U", dataKey: "uso_cta" },
        { header: "Condicion", dataKey: "condicion" },
      ];
      var body = [];

      this.cuentasc.map(function (x) {
        body.push({
          denominacion: x.denominacion,
          cuenta: x.cuenta,
          tipo_cta: x.tipo_cta,
          uso_cta: x.uso_cta,
          condicion: x.condicion == 1 ? "Activo" : "Inactivo",
        });
      });
      //console.log(body);
      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE CUENTAS CONTABLES", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
          doc.addImage(imgData, "JPEG", 40, 17, 35, 40);
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          cuenta: { cellWidth: 60 },
          denominacion: { cellWidth: "auto", },
          tipo_cta: { cellWidth: 17 },
          uso_cta: { cellWidth: 17 },
          condicion: { cellWidth: 45.28, halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Cuentasc.pdf");
    },
    /* Fin Crear PDF cuentas c. */
  },
};
</script>
